export function matchesCompetitionFilter(item, filter) {
  if (filter === "open") return item.registrationOpen === true;
  if (filter === "events") return item.typeKey === "single_event";
  if (filter === "championships") return item.typeKey === "championship";
  return true;
}
